export default __webpack_public_path__ + "static/media/arrow-down.20b07b87.svg";